module.exports = __webpack_public_path__ + "static/media/view6.0a9158f4.jpg";